import TraceLevel from './TraceLevel';
const listeners: TraceListener[] = [];

export interface TraceErrorObject extends Error {
    filename?: string;
    lineno?: number;
    colno?: number;
    diagnosticInfo?: string;
    networkError?: boolean;
    component?: boolean;
    scriptEval?: boolean;
    httpStatus?: number;
}

export type TraceListener = (
    message: string,
    tracelevel?: TraceLevel,
    errorObject?: TraceErrorObject
) => any;

export function registerTracerListener(traceListener: TraceListener) {
    listeners.push(traceListener);
}

function trace(message: string, traceLevel: TraceLevel, errorObject?: TraceErrorObject) {
    listeners.forEach(listener => {
        listener(message, traceLevel, errorObject);
    });
}

function info(message: string) {
    trace(message, TraceLevel.Info);
}

function warn(message: string) {
    trace(message, TraceLevel.Warning);
}

function verbose(message: string) {
    trace(message, TraceLevel.Verbose);
}

interface InternalTraceErrorObject extends TraceErrorObject {
    error?: Error;
}

function error(msg: TraceErrorObject | string, error?: TraceErrorObject) {
    // if there is no info, then we have nothing to report
    let info: InternalTraceErrorObject;
    if (typeof msg === 'string') {
        info = error || new Error(msg);
        info.message = msg;
    } else {
        info = msg;
    }

    if (info.error?.message && info.error.stack) {
        info.message = info.error.message;
        info.stack = info.error.stack;
        info.name = info.error.name;
    }

    if (info.component) {
        info.message = 'COMPONENT ERROR: ' + info.message;
    } else if (info.scriptEval) {
        info.message = 'EVAL ERROR: ' + info.message;
    }

    trace(info.message || '', TraceLevel.Error, info);
}

export default {
    info,
    warn,
    error,
    verbose,
};
